import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotConversation } from 'models/copilot/copilotConversation';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';

export class TenantProcessStateTaskEvidenceAudit {
  taskId: number;

  conversation: CopilotConversation;

  constructor() {
    this.taskId = 0;
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateTaskEvidenceAuditDTO {
  taskId: number;

  conversation: CopilotConversationDTO;

  constructor() {
    this.taskId = 0;
    this.conversation = new CopilotConversationDTO();
  }
}

export class CopilotTaskEvidenceAuditContent extends CopilotPanelContentBase {
  public readonly context: CopilotPanelContext;

  taskId: number;

  constructor(taskId: number) {
    super();
    this.context = CopilotPanelContext.TaskEvidenceAudit;
    this.taskId = taskId;
  }
}
